import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'vfs-title-bar',
  templateUrl: './title-bar.component.html',
  styleUrls: ['./title-bar.component.scss']
})
export class TitleBarComponent implements OnChanges {
  @Input() icon: string;
  @Input() title: string;
  @Input() backRoute: string[];
  @Input() backState: { [k: string]: any };

  constructor(protected router: Router, protected titleService: Title) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.title.currentValue) {
      this.titleService.setTitle(this.title);
    }
  }

  onBackClick() {
    this.router.navigate(this.backRoute, { state: this.backState });
  }
}
